<div class="modal-content">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p class="modal-title h4">{{ 'modals.confirmDelivery.title' | translate }}</p>
  </div>
  <div class="modal-body text-left">
    <div class="row">
      <div class="col-12">
        <div class="alert alert-info d-flex">
          <jhi-bary-icon icon="clipboard-check" [faDirective]="FAS" size="2x"></jhi-bary-icon>
          <div class="ml-2" [innerHTML]="'modals.confirmDelivery.message' | translate"></div>
        </div>
      </div>

      <div class="col-12">
        <jhi-bary-date-picker [label]="'modals.confirmDelivery.input.deliveryDate' | translate" [control]="controls.deliveryDate" [options]="dateOption"></jhi-bary-date-picker>
      </div>

      <div class="col-12">
        <jhi-bary-title [title]="'modals.confirmDelivery.input.pod' | translate"></jhi-bary-title>
      </div>
      <div class="col-12">
        <jhi-bary-file-upload-visual
          #podUploader
          [style]="'border-radius: 10px'"
          [actionURL]="podURL(transportOrderId)"
          [control]="controls.podControl"
          [previewControl]="controls.picturePreview"
          [maxWidth]="2048"
          [maxHeight]="2048"
          [displayCircle]="false"
          [label]="'modals.confirmDelivery.input.pod' | translate"
          icon="image"
        ></jhi-bary-file-upload-visual>
      </div>
    </div>
  </div>

  <!--Footer-->
  <div class="modal-footer justify-content-end">
    <jhi-bary-button (clickEvent)="handleClick({ second: true })" [label]="'modals.confirmDelivery.cancel' | translate" [outline]="true" class="mr-2"></jhi-bary-button>
    <jhi-bary-button color="primary" [label]="'modals.confirmDelivery.submit' | translate" (clickEvent)="handleClick({ submit: true })"></jhi-bary-button>
  </div>
</div>
